import React, { useState } from "react";
import Layout from "./Layout";
import { validateForm } from "../utils/validation";
import PaymentSuccessPop from "../components/popup/paymentSuccessPop";
import { contactSubmit } from "../redux/apis/pageAPI";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [disable, setDisable] = useState(false);

  const submitForm = async () => {
    setDisable(true);
    setErrorMessage("");
    const submit = {
      name,
      email,
      number,
      message,
    };
    const vali = validateForm(submit, []);
    if (vali === true) {
      await contactSubmit(submit);
      setSuccess(true);
    } else {
      setErrorMessage(`${vali} field is invalid`);
      setDisable(false);
    }
  };

  return (
    <Layout>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <h2 className="text-3xl font-bold text-indigo-600 sm:text-4xl text-left mb-4">
            Contact Us
          </h2>
          <div className="mt-2 text-sm leading-8 text-gray-600 text-left">
            <b>Toll free</b>: 1.866.542.9099
            <br />
            <b>Local</b>: 519.253.9099
            <br />
            <b>Fax</b>: 519.253.2424
            <br />
            <b>Email</b>:{" "}
            <a href="mailto: sales@runningcount.com">sales@runningcount.com</a>
            <br />
            <b>Physical Address</b>:<br />
            Running Count Inc.
            <br />
            2355 Edna St., Unit B Windsor, ON, N8Y 4W8
            <br />
            <b>U.S Address:</b>
            <br />
            Running Count Inc.
            <br />
            100 Summit St. Detroit, MI, 48209
            <br />
            <b>Mailing Address (letter mail only):</b>
            <br />
            Running Count Inc.
            <br />
            598 Huron St. LaSalle, ON, N9J 3Z4
          </div>
        </div>
        {!success ? (
          <div>
            <form action="#" method="POST" className="mx-auto mt-10 lg:mt-0">
              <div>
                <div>
                  <label
                    htmlFor="last-name"
                    className="block text-sm font-semibold leading-6 text-gray-900"
                  >
                    Name
                  </label>
                  <div className="mt-2.5">
                    <input
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                      type="text"
                      name="last-name"
                      id="last-name"
                      autoComplete="family-name"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div className="mt-2">
                  <label
                    htmlFor="email"
                    className="block text-sm font-semibold leading-6 text-gray-900"
                  >
                    Email
                  </label>
                  <div className="mt-2.5">
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      type="email"
                      name="email"
                      id="email"
                      autoComplete="email"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div className="mt-2">
                  <label
                    htmlFor="phone-number"
                    className="block text-sm font-semibold leading-6 text-gray-900"
                  >
                    Phone number
                  </label>
                  <div className="relative mt-2.5">
                    <input
                      onChange={(e) => setNumber(e.target.value)}
                      value={number}
                      type="tel"
                      name="phone-number"
                      id="phone-number"
                      autoComplete="tel"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div className="mt-2">
                  <label
                    htmlFor="message"
                    className="block text-sm font-semibold leading-6 text-gray-900"
                  >
                    Message
                  </label>
                  <div className="mt-2.5">
                    <textarea
                      onChange={(e) => setMessage(e.target.value)}
                      value={message}
                      name="message"
                      id="message"
                      rows={4}
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      defaultValue={""}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-10">
                {errorMessage !== "" && (
                  <div
                    className="bg-red-100 border border-red-400 text-red-700 px-4 rounded relative mb-4"
                    role="alert"
                  >
                    <strong className="font-bold">Error! </strong>
                    <span className="block sm:inline">{errorMessage}</span>
                  </div>
                )}
                <div
                  onClick={submitForm}
                  className={`mb-6 w-full rounded-md px-6 py-3 font-medium text-white hover:text-white text-center ${
                    disable
                      ? "bg-gray-500 cursor-not-allowed"
                      : "bg-indigo-600 cursor-pointer"
                  }`}
                >
                  {disable ? (
                    <div role="status" className="w-fit m-auto">
                      <svg
                        aria-hidden="true"
                        className="w-5 h-5 text-gray-100 animate-spin dark:text-gray-200 fill-indigo-400"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  ) : (
                    "Submit"
                  )}
                </div>
              </div>
            </form>
          </div>
        ) : (
          <b className="text-green-500">
            We received your message, will get back to you shortly!
          </b>
        )}
      </div>
      {success === true ? (
        <PaymentSuccessPop checkoutState={"contact"} />
      ) : null}
    </Layout>
  );
}
